import React from "react";
import UploadHoursForm from "../../Components/UploadHoursForm/uploadHoursForm.jsx";
import { getUserId } from "../../Utils/helper";
import "./styles.css";

/*
-=-=-=-=-=-=-=-=-=-=-=-= Upload Hours Page -=-=-=-=-=-=-=-=-=-=-=-=
=-=-=-=-=-=-=-= https://atlasboard.wsu-idp.org/hours =-=-=-=-=-=-=-
*/
function HoursPage() {
  const userId = getUserId();
  return (
    <div className="page-content">
      <div className="upload-hours-page contentBox">
        <UploadHoursForm userId={userId} />
      </div>
    </div>
  );
}

export default HoursPage;
